import { useState, useEffect } from "react"
import { Button, DialogContent, Grid, InputAdornment, TextField } from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { closeMoadalAltaCiurcuito, crearCirucuitoAction, obtenerCicuitosProvedor } from "./../../../ducks/proveedorTerrestreDuck"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import { esFechaValida } from "../../../utils/FormatFecha"
import TCircuitosProveedor from "./TCircuitosProveedor"
import PickerMod from "../../../global/PickersMod"
import ModalRegiones from "./ModalRegiones"
import useCatalogos from "../../../hooks/useCatalogos"
import { DialogMessage } from "../../../global/DialogMessage"
import { formatDinero } from "../../../utils/formatDinero"
import Swal from "sweetalert2"
import AirplanemodeActiveIcon from '@material-ui/icons/AirplanemodeActive';
import AirplanemodeInactiveIcon from '@material-ui/icons/AirplanemodeInactive';
import { obetenerPaqueteMayoristaListaDetalle } from "../../../ducks/proveedorMayoristaDuck"
import { FCircuitoStyles } from "./styles"

const validationSchema = yup.object({
    disponibilidad: yup
        .number("Ingresa un numero")
        .positive("numero postivo")
        .required("Es requerido"),
    claveCircuito: yup
        .string("")
        .required("Se requiere clave"),
    dias: yup
        .number("Ingresa un número de días")
        .positive("Número positivo")
        .min(1, "Debe ser al menos 1 día")
        .required("Es requerido"),
    noches: yup
        .number("Ingresa un número de noches")
        .required("Es requerido"),
    suplemento: yup
        .number("Ingresa un suplemento")
        .required("Es requerido"),
})

const initialValues = {
    disponibilidad: 0,
    claveCircuito: "",
    dias: 1,
    noches: 0,
    suplemento: 0,
}

const useProvedorTerrestreCircuitos = ({ id }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCicuitosProvedor({ id })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, id])
}

const FCircuitos = () => {
    const dispatch = useDispatch();
    const classes = FCircuitoStyles();
    const [fechaInicio, setFechaIncio] = useState(new Date())
    const [fechaFin, setFechaFin] = useState(new Date())
    const [errorFecha, setErrorFecha] = useState("");
    const [openModalRegiones, setOpenModalRegiones] = useState(false);

    const catalogoRegiones = useCatalogos("Region");
    const [LPaqueteCircuitoRegion, setLPaqueteCircuitoRegion] = useState([]);

    const { provedorCircuito, openCirutoAlta, paqueteSelect } = useSelector(store => store.proveedorTerrestre)
    useProvedorTerrestreCircuitos({ id: provedorCircuito?.idProveedor })
    
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (errorFecha) {
                ToastMessage.fire({ icon: "error", title: errorFecha });
                return;
            }

            if (LPaqueteCircuitoRegion.length === 0) {
                DialogMessage.fire({
                    title: 'Sin regiones seleccionadas',
                    html: 'Debes seleccionar al menos una región antes de continuar.',
                    icon: 'warning',
                    confirmButtonText: 'Entendido',
                });
                return;
            }
        
            DialogMessage.fire({
                title: '¿Estas seguro de crear este circuito?',
                html: `<ul class="custom-list" style="padding: 0; list-style: none;">
                        <li style="margin-bottom: 0.5rem;">
                            <strong>Nombre</strong>: ${values?.claveCircuito}
                        </li>
                        <li style="margin-bottom: 0.5rem;">
                            <strong>Disponibilidad</strong>: ${values?.disponibilidad}
                        </li>
                        <li style="margin-bottom: 0.5rem;">
                            <strong>Días</strong>: ${values?.dias} / <strong>Noches</strong>: ${values?.noches}
                        </li>
                        <li style="margin-bottom: 0.5rem;">
                            <strong>Suplemento</strong>: ${formatDinero(values?.suplemento)} ${paqueteSelect?.Moneda ? paqueteSelect?.Moneda?.Clave : ""}
                        </li>
                        <li style="margin-bottom: 0.5rem;">
                            <strong>Regiones con vuelo</strong>: ${regionesConVuelo.map((r) => r.Descripcion).join(", ") || "Ninguna"}
                        </li>
                        <li style="margin-bottom: 0.5rem;">
                            <strong>Regiones solo terrestres</strong>: ${regionesTerrestres.map((r) => r.Descripcion).join(", ") || "Ninguna"}
                        </li>
                    </ul>`,
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: '¡Crear y continuar!',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    onSave(values);
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    ToastMessage.fire('Cancelado', 'No se ha realizado ningún cambio', 'info');
                }
            });
        }
        
    })

     // Muestra el nombre de las regiones seleccionadas
    const regionesSeleccionadas = catalogoRegiones.filter((reg) =>
        LPaqueteCircuitoRegion.some((r) => r.IdCatRegion === reg.IdCatRegion)
    );

    const regionesConVuelo = regionesSeleccionadas.filter(r => 
        LPaqueteCircuitoRegion.some(region => region.IdCatRegion === r.IdCatRegion && region.IncluyeVuelo)
    );
    const regionesTerrestres = regionesSeleccionadas.filter(r => 
        LPaqueteCircuitoRegion.some(region => region.IdCatRegion === r.IdCatRegion && !region.IncluyeVuelo)
    );

    const getIconVuelo = (idRegion) => {
        const region = LPaqueteCircuitoRegion.find(r => r.IdCatRegion === idRegion);
        if (region) {
            return region.IncluyeVuelo 
                ? <AirplanemodeActiveIcon style={{ marginLeft: 4 }} color="primary" fontSize="small" /> 
                : <AirplanemodeInactiveIcon style={{ marginLeft: 4 }} color="disabled" fontSize="small" />;
        }
        return null;
    };
    const claerForm = () => {
        formik.resetForm(initialValues)
        setFechaIncio(new Date())
        setFechaFin(new Date())
    }
    const handleClose = () => {
        dispatch(closeMoadalAltaCiurcuito())
        claerForm()
        setLPaqueteCircuitoRegion([]); // Limpia las regiones al cerrar el modal
    }

    const handleClickSelecFechaInicio = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        setFechaIncio(date)
    }
    const handleClickSelecFechaFinal = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        setFechaFin(date)
    }

    const handleDiasChange = (e) => {
        const newDias = e.target.value;
        formik.setFieldValue("dias", newDias);
        formik.setFieldValue("noches", newDias - 1 <= 0 ? 0 : newDias - 1);
    };
    
    const handleNochesChange = (e) => {
        const newNoches = e.target.value;
        formik.setFieldValue("dias", Number(newNoches) + 1);
        formik.setFieldValue("noches", newNoches);
    };

    const onSave = (values) => {
        dispatch(onLoadAnction({ message: '' }))
        dispatch(crearCirucuitoAction({
            // ClaveCircuito: `${provedorCircuito?.claveProveedor}FI${FormatoFecha({ date: fechaInicio, formato: "yyyy-MM-dd-HH:MM" })}FF${FormatoFecha({ date: fechaFin, formato: "yyyy-MM-dd-HH:MM" })}`,
            ClaveCircuito: values.claveCircuito,
            Disponibilidad: Number(values.disponibilidad),
            FechaFin: fechaFin,
            FechaInicio: fechaInicio,
            id: provedorCircuito?.idProveedor,
            Dias: Number(values.dias),
            Noches: Number(values.noches),
            Suplemento: Number(values.suplemento),
            LPaqueteCircuitoRegion
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerCicuitosProvedor({ id: provedorCircuito?.idProveedor }))
             dispatch(obetenerPaqueteMayoristaListaDetalle())
            claerForm()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }

    useEffect(() => {
        const calcularDias = () => {
            const diffTime = fechaFin - fechaInicio;
            const dias = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Diferencia en días

            if (dias < 1) {
                setErrorFecha("La fecha de fin debe ser después de la fecha de inicio.");
                formik.setFieldValue("dias", 1);
                formik.setFieldValue("noches", 0);
            } else {
                setErrorFecha("");
                formik.setFieldValue("dias", dias);
                formik.setFieldValue("noches", dias - 1 <= 0 ? 0 : dias - 1);
            }
        };
        calcularDias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fechaInicio, fechaFin]);

    return (
        <div>	
            <ModalBase classes={classes} open={openCirutoAlta} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo bloque de fechas ${paqueteSelect ? "para el paquete " + paqueteSelect?.Nombre : ""}`}
                />

                <DialogContent dividers style={{ height: "80vh", maxHeight: '650px', overflowY: 'auto'}}>
                    <form onSubmit={formik.handleSubmit}>	
                        <Grid container className={classes.containerSpacing}>
                            <Grid item xs={4}>
                                <TextField
                                    required
                                    id="input-clave-ciurcuito"
                                    label="Clave"
                                    type="text"
                                    variant="outlined"
                                    name="claveCircuito"
                                    value={formik.values.claveCircuito}
                                    onChange={formik.handleChange}
                                    error={formik.touched.claveCircuito && Boolean(formik.errors.claveCircuito)}
                                    helperText={formik.touched.claveCircuito && formik.errors.claveCircuito}
                                    className={classes.textField}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField
                                    required
                                    id="input-Diponibilidad-ciurcuito"
                                    label="Disponibilidad"
                                    type="text"
                                    variant="outlined"
                                    name="disponibilidad"
                                    value={formik.values.disponibilidad}
                                    onChange={formik.handleChange}
                                    error={formik.touched.disponibilidad && Boolean(formik.errors.disponibilidad)}
                                    helperText={formik.touched.disponibilidad && formik.errors.disponibilidad}
                                    className={classes.textField}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField
                                    required
                                    id="input-Suplemento"
                                    label="Suplemento"
                                    type="text"
                                    variant="outlined"
                                    name="suplemento"
                                    value={formik.values.suplemento}
                                    onChange={formik.handleChange}
                                    error={formik.touched.suplemento && Boolean(formik.errors.suplemento)}
                                    helperText={formik.touched.suplemento && formik.errors.suplemento}
                                    className={classes.textField}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                            {paqueteSelect?.Moneda ? `${paqueteSelect?.Moneda.Clave}` : ""}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <PickerMod
                                    id="fechaIncioCircuito"
                                    label="Inicio"
                                    selectedDate={fechaInicio}
                                    setSelectedDate={handleClickSelecFechaInicio}
                                    disablePast={true}
                                    disableFuture={false}
                                    className={classes.dateField}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <PickerMod
                                    id="fechaFinalCircuito"
                                    label="Fin"
                                    selectedDate={fechaFin}
                                    setSelectedDate={handleClickSelecFechaFinal}
                                    disablePast={true}
                                    disableFuture={false}
                                    className={classes.dateField}
                                />
                            </Grid>
                            
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="input-Dias"
                                    label="Dias"
                                    type="text"
                                    variant="outlined"
                                    name="dias"
                                    value={formik.values.dias}
                                    onChange={handleDiasChange}
                                    error={formik.touched.dias && Boolean(formik.errors.dias)}
                                    helperText={formik.touched.dias && formik.errors.dias}
                                    className={classes.textField}
                                />
                            </Grid>
                            
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="input-Noches"
                                    label="Noches"
                                    type="text"
                                    variant="outlined"
                                    name="noches"
                                    value={formik.values.noches}
                                    onChange={handleNochesChange}
                                    error={formik.touched.noches && Boolean(formik.errors.noches)}
                                    helperText={formik.touched.noches && formik.errors.noches}
                                    className={classes.textField}
                                />
                            </Grid>
                        </Grid>
                        
                        <Grid container className={classes.containerSpacing}>
                            <Grid item xs={6} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <Button 
                                    type="button" 
                                    variant="contained" 
                                    color="secondary" 
                                    onClick={() => setOpenModalRegiones(true)}
                                    style={{ display: 'flex', flexWrap: 'wrap' }}
                                >
                                    {regionesSeleccionadas.length > 0
                                        ? (<div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                              <span style={{ marginRight: 4 }}>Regiones:</span>
                                              {regionesSeleccionadas.map((r, index) => (
                                                <span key={r.IdCatRegion} style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                                                  {r.Descripcion}
                                                  {getIconVuelo(r.IdCatRegion)}
                                                  {index !== regionesSeleccionadas.length - 1 && ','}
                                                </span>
                                              ))}
                                          </div>)
                                        : "Seleccionar Regiones"
                                    }
                                </Button>
                                <ModalRegiones 
                                    open={openModalRegiones} 
                                    handleClose={() => setOpenModalRegiones(false)} 
                                    catalogoRegiones={catalogoRegiones}
                                    setLPaqueteCircuitoRegion={setLPaqueteCircuitoRegion}
                                />
                            </Grid>

                            <Grid item xs={6} className={classes.modalBotonesCenter}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.modalBoton}
                                >
                                    Guardar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>

                    <Grid container className={classes.containerSpacing}>
                        <TCircuitosProveedor />
                    </Grid>
                </DialogContent>
            </ModalBase>
        </div>
    )
}
export default FCircuitos